import gql from 'graphql-tag';
import FieldsJobtitle from 'graphql/fields/FieldsJobtitle';
import HelperGraphql from 'utils/helper-graphql';

const fields = {
	'active': '[String]',
	'search': 'String'
};

export default gql(`
	query jobtitles( ${ HelperGraphql.createFields( fields ) } ) {
		jobtitles( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsJobtitle}
			
			employee_count( ${ HelperGraphql.createVariables( fields ) } )
		}
	}
`);

